export class User{

  usuario: string;
  password: string;
}
